// import node module libraries
import { Fragment, useContext } from 'react';
import { useMediaQuery } from 'react-responsive';
import { NavDropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

// import context file
import { AppConfigContext } from 'context/Context';

const PricingMenu = ({ className }) => {
	const { t } = useTranslation();
	const ConfigContext = useContext(AppConfigContext);

	const isDesktop = useMediaQuery({
		query: '(min-width: 1224px)'
	});

	const ComparePlanMenuHTML = () => {
		return (
			<div className="ms-3 lh-3">
				<h5 className="mb-0">{t('Prices & Plans')}</h5>
				<p className="mb-0 fs-6">{t('Compare all features')}</p>
			</div>
		);
	};

	const PricingMenuDesktop = () => {
		return (
			<NavDropdown
				title={t('Infos')}
				id="basic-nav-dropdown"
				bsPrefix="d-block nav-link"
				className={className}
				show
			>
				<NavDropdown.Item href="/marketing/pages/compare-plan/" className="py-2 px-3">
					<div className="d-flex align-items-center">
						<i className="fe fe-layers fs-3 text-primary"></i>
						<ComparePlanMenuHTML />
					</div>
				</NavDropdown.Item>
			</NavDropdown>
		);
	};
	const PricingMenuMobile = () => {
		return (
			<NavDropdown
				title="Infos"
				id="basic-nav-dropdown"
				bsPrefix="d-block nav-link"
			>
				<NavDropdown.Item href="/marketing/pages/compare-plan" className="py-2 px-3">
					<div className="d-flex align-items-center">
						<i className="fe fe-layers fs-3 text-primary"></i>
						<ComparePlanMenuHTML />
					</div>
				</NavDropdown.Item>
			</NavDropdown>
		);
	};

	return (
		<Fragment>{isDesktop ? <PricingMenuDesktop /> : <PricingMenuMobile />}</Fragment>
	);
};

export default PricingMenu;
